// document.addEventListener("DOMContentLoaded", function () {
//     let selectElements = document.querySelectorAll(".product-variant-container.single-option-selector");
//     let dropdownContainer = document.querySelector(".custom-dropdown_sec");
//     let dropdownOptions = document.querySelector(".dropdown-options_sec");
//     let selectedTitle = document.querySelector(".selected-title_sec");
//     let selectedImage = document.querySelector(".selected-image_sec");
//     let dropdownSelected = document.querySelector(".dropdown-selected_sec");
//     let bulkImagePreview = document.createElement("div");
//     bulkImagePreview.classList.add("hulk-big-image_sec");
//     document.body.appendChild(bulkImagePreview);

//     if (!selectElements.length || !dropdownContainer || !dropdownOptions || !selectedTitle || !selectedImage || !dropdownSelected) {
//         console.warn("Required elements not found!");
//         return;
//     }

//     function updateDropdown() {
//         dropdownOptions.innerHTML = ""; // Reset dropdown items
//         let allImages = [];

//         selectElements.forEach(selectElement => {
//             let selectedOption = selectElement.options[selectElement.selectedIndex];
//             if (!selectedOption) return;

//             let metafieldData = selectedOption.getAttribute("data-variant-metafield");
//             if (!metafieldData || metafieldData === "null" || metafieldData === "") return;

//             try {
//                 let parsedData = JSON.parse(metafieldData);
//                 let images = parsedData.images;

//                 if (images && images.length > 0) {
//                     allImages = allImages.concat(images);
//                 }
//             } catch (error) {
//                 console.error("Invalid JSON in data-variant-metafield:", error);
//             }
//         });

//         if (allImages.length === 0) {
//             dropdownContainer.style.display = "none"; // Hide dropdown if no images
//             return;
//         }

//         dropdownContainer.style.display = "block"; // Show dropdown
//         selectedTitle.innerText = "-";
//         selectedImage.innerHTML = ``;

//         allImages.forEach((image, index) => {
//             let li = document.createElement("li");
//             li.setAttribute("data-id", index);
//             li.setAttribute("data-image", image.image);

//             li.innerHTML = `
//                 <span class="variant-title_sec">${image.title}</span>
//                 <span class="variant-image_sec">
//                     <img src="${image.image}" width="30" height="26" alt="${image.title}">
//                 </span>
//             `;

//             li.addEventListener("click", function () {
//                 selectedTitle.innerText = image.title;
//                 selectedImage.innerHTML = `<img src="${image.image}" width="30" height="26" alt="${image.title}">`;

//                 document.querySelectorAll(".dropdown-options_sec li").forEach(item => item.classList.remove("selected"));
//                 li.classList.add("selected");
//                 dropdownOptions.classList.remove("show");
//             });

//             li.addEventListener("mouseenter", function () {
//                 bulkImagePreview.innerHTML = `<img src="${image.image}" alt="${image.title}">`;
//                 bulkImagePreview.style.display = "block";
//             });

//             li.addEventListener("mouseleave", function () {
//                 bulkImagePreview.style.display = "none";
//             });

//             dropdownOptions.appendChild(li);
//         });
//     }

//     dropdownSelected.addEventListener("click", function (event) {
//         event.stopPropagation();
//         dropdownOptions.classList.toggle("show");
//     });

//     document.addEventListener("click", function (event) {
//         if (!dropdownContainer.contains(event.target)) {
//             dropdownOptions.classList.remove("show");
//         }
//     });

//     // Listen for changes on all select elements
//     selectElements.forEach(selectElement => {
//         selectElement.addEventListener("change", updateDropdown);
//     });

//     updateDropdown(); // Initial setup
// });

function option_selected_remove_styling() {
    const parentDiv = document.querySelector('.related-product.json_data_info'); // Targeting the parent div

    if (parentDiv) {
        // Resetting the styles
        parentDiv.style.background = '';
        parentDiv.style.padding = '';
        parentDiv.style.borderRadius = '';
        parentDiv.style.border = '';
    }
}
document.addEventListener("DOMContentLoaded", function () {
    let selectElements = document.querySelectorAll(".product-variant-container.single-option-selector");
    let dropdownContainer = document.querySelector(".custom-dropdown_sec");
    let dropdownOptions = document.querySelector(".dropdown-options_sec");
    let selectedTitle = document.querySelector(".selected-title_sec");
    let selectedImage = document.querySelector(".selected-image_sec");
    let dropdownSelected = document.querySelector(".dropdown-selected_sec");
    let variantSwatchData = document.querySelector(".variant_swatch_data"); // Hidden field container
    let bulkImagePreview = document.createElement("div");
    let title_swatch = document.querySelector(".related-product-name_sec");
    let pro_title = document.querySelector(".product-title"); // Product Title
    
    bulkImagePreview.classList.add("hulk-big-image_sec");
    document.body.appendChild(bulkImagePreview);

    if (!selectElements.length || !dropdownContainer || !dropdownOptions || !selectedTitle || !selectedImage || !dropdownSelected || !variantSwatchData || !pro_title) {
        console.warn("Required elements not found!");
        return;
    }
//debugger;
    function updateDropdown() {
      //debugger;
         dropdownOptions.innerHTML = ""; // Reset dropdown items
      var curr_variant_id = findMatchedVariant(product_js.variants).id;

      var current_swatches = getSwatchesByVariantId(curr_variant_id);
      
      let allImages = [];
      if(current_swatches.swatches != null && current_swatches.swatches.length > 0){
        allImages = current_swatches.swatches;
      }


        if (allImages.length === 0) {
            dropdownContainer.style.display = "none"; // Hide dropdown if no images
            title_swatch.style.display = "none";
            return;
        }

        dropdownContainer.style.display = "block"; // Show dropdown
        title_swatch.style.display = "block";
        selectedTitle.innerText = "-";
        selectedImage.innerHTML = ``;

        allImages.forEach((image, index) => {
            let li = document.createElement("li");
            li.setAttribute("data-id", index);
            li.setAttribute("data-image", image.image);

            li.innerHTML = `
                <span class="variant-title_sec">${image.title}</span>
                <span class="variant-image_sec">
                    <img src="${image.image}" width="30" height="26" alt="${image.title}">
                </span>
            `;

            li.addEventListener("click", function () {
                selectedTitle.innerText = image.title;
                selectedImage.innerHTML = `<img src="${image.image}" width="30" height="26" alt="${image.title}">`;

                // Remove previous hidden input fields
                variantSwatchData.innerHTML = "";

                // Get selected variant title
                let selectedVariantTitle = "";
                selectElements.forEach(selectElement => {
                    let selectedOption = selectElement.options[selectElement.selectedIndex];
                    if (selectedOption) {
                        selectedVariantTitle += selectedOption.innerText + " ";
                    }
                });
                selectedVariantTitle = selectedVariantTitle.trim(); // Remove extra spaces

                // **New Hidden Input**
                const inputTitle = document.createElement('input');
                inputTitle.type = 'hidden';
                inputTitle.name = `properties[upholstery_option]`; // Updated Name
                inputTitle.value = `${pro_title.innerText} | ${selectedVariantTitle} | ${image.title}`; // Updated Value
                
                variantSwatchData.appendChild(inputTitle);

                document.querySelectorAll(".dropdown-options_sec li").forEach(item => item.classList.remove("selected"));
                li.classList.add("selected");
                option_selected_remove_styling();
                dropdownOptions.classList.remove("show");
            });

            li.addEventListener("mouseenter", function () {
                bulkImagePreview.innerHTML = `<img src="${image.image}" alt="${image.title}">`;
                bulkImagePreview.style.display = "block";
            });

            li.addEventListener("mouseleave", function () {
                bulkImagePreview.style.display = "none";
            });

            dropdownOptions.appendChild(li);
        });
    }

    dropdownSelected.addEventListener("click", function (event) {
        event.stopPropagation();
        dropdownOptions.classList.toggle("show");
    });

    document.addEventListener("click", function (event) {
        if (!dropdownContainer.contains(event.target)) {
            dropdownOptions.classList.remove("show");
        }
    });

    // Listen for changes on all select elements
    selectElements.forEach(selectElement => {
        selectElement.addEventListener("change", updateDropdown);
    });

    updateDropdown(); // Initial setup
});
